import React, { Component, createRef } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { get as _get } from "lodash";
import Helmet from "react-helmet";

import { Link } from "react-router-dom";

import { showAlertMessage, EmptyLabel } from "../../resusableComponents/common/formElements";
import { hasAccess } from "../../resusableComponents/hoc/AccessManagement";
import { withRouter } from "../../resusableComponents/hoc/withRouter";
import { updateLoadingState } from "../../redux/actions/application";
import { fetchCampaignDetails } from "../../redux/services/campaign";

class ViewDeepResearchReport extends Component {

  constructor(props) {
    super(props);

    this.state = {
      campaignId: _get(this.props, "params.id", 0),
      campaignDetails: {},
    };

    this.reportContainerRef = createRef();
  }

  componentDidMount() {
    this._fetchPageData();
  }

  _fetchPageData = async () => {
    const { updateLoadingState } = this.props;

    if (typeof updateLoadingState === "function") { updateLoadingState(true); }

    try {
      await Promise.all([
        this._fetchCampaignDetails(),
      ]);
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _fetchCampaignDetails = async () => {
    const { campaignId } = this.state;

    if (!campaignId) { return; }

    try {
      const response = await fetchCampaignDetails(campaignId);

      if (_get(response, "flag", false) === true) {
        const campaignDetails = _get(response, "data.campaign_detail[0]", {});
        this.setState({ campaignDetails });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching campaign details."));
      }
    } catch (err) {
      showAlertMessage((err.message || "Something went wrong while fetching campaign details."));
    }
  };



  _handleContainerClick = (e) => {
    const btn = e.target.closest('.nav-link');
    if (!btn) return;

    const targetTabId = btn.getAttribute('data-target');
    if (!targetTabId) return;

    // Walk up to the parent <ul class="nav nav-tabs"> that owns this button
    const navList = btn.closest('ul.nav');
    if (!navList) return;

    // 1. Deactivate all sibling nav-link buttons within this nav group only
    navList.querySelectorAll('.nav-link').forEach(sibling => sibling.classList.remove('active'));

    // 2. Activate the clicked button
    btn.classList.add('active');

    // 3. Find the tab-content that is a sibling of this nav list
    //    (works for both outer tabs and nested inner tabs)
    const tabContent = navList.parentElement
      ? navList.parentElement.querySelector(':scope > .tab-content')
      : null;

    if (tabContent) {
      // Hide all panes inside this tab-content only
      tabContent.querySelectorAll(':scope > .tab-pane').forEach(pane => {
        pane.classList.remove('active');
      });

      // Show the target pane
      const targetPane = tabContent.querySelector(`#${targetTabId}`);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    }
  };

  _renderButtons = () => {
    const { campaignId } = this.state;

    return (
      <div className="row gy-4 mb-4">
        {hasAccess("campaigns", "dashboard") && (
          <div className="col-xxl-3 col-xl-auto col-lg-auto">
            <div className="input-group">
              <span className="input-group-text bg-primary border-primary ps-3 d-flex align-items-center input-group-rounded">
                <img src={require("../../assets/icons/icon-dashboard-alt.svg").default} className="img-fluid" alt="img" />
              </span>
              <Link to={`/campaigns/dashboard/${campaignId}`} className="btn btn-primary waves-effect">
                <FormattedMessage id="campaign_content.btn.campaign_dashboard" defaultMessage="campaign dashboard" />
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  };

  _renderReportContent = () => {
    const { campaignDetails } = this.state;
    const reportHtmlContent = _get(campaignDetails, "html_content", "");

    if (!reportHtmlContent) {
      return (
        <div className="d-flex justify-content-center align-items-center py-6">
          <EmptyLabel />
        </div>
      );
    }

    let bodyContent = reportHtmlContent;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(reportHtmlContent, "text/html");
      if (doc.body) {
        bodyContent = doc.body.innerHTML;
      }
    } catch (e) {
      console.error("Error parsing HTML", e);
    }

    return (
      <div className="card">
        <div className="card-body p-4 deep-research-report-section">
          <div ref={this.reportContainerRef} onClick={(e) => this._handleContainerClick(e)} dangerouslySetInnerHTML={{ __html: bodyContent }} />
        </div>
      </div>
    );
  };


  render() {
    const { intl } = this.props;
    const { campaignDetails } = this.state;

    const campaignName = _get(campaignDetails, "campaign_name", "");

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "hermes.view_deep_research_report", defaultMessage: "Analysis Report: Hermes" })}
          </title>
        </Helmet>

        <div className="container-fluid flex-grow-1 px-6 py-6">

          {/* Campaign Header */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-5 py-3 px-4">
                    <p className="heading-04 text-uppercase">
                      {campaignName || <EmptyLabel />}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Page Title & Buttons */}
          <div className="row mt-5">
            <div className="col-lg-12">
              <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-5">
                <FormattedMessage id="view_deep_research_report.title" defaultMessage="Analysis Report" />
              </h1>
            </div>
          </div>

          {this._renderButtons()}

          {/* Report Content */}
          <div className="row mt-4">
            <div className="col-lg-12">
              {this._renderReportContent()}
            </div>
          </div>

        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default withRouter(connect(null, mapDispatchToProps)(injectIntl(ViewDeepResearchReport)));
